import sha256 from "crypto-js/sha256";

import { ShopFulfillmentMethod } from "@/types/enums/shop-fulfillment-method";

interface ShopCheckoutIdempotencyInput {
  buyerId?: string;
  checkoutNonce?: string;
  cartFingerprint: string;
  pickupLocationId?: string | null;
  fulfillmentMethod?: ShopFulfillmentMethod | null;
  shippingAddressFingerprint?: string | null;
}

export function buildShopCheckoutIdempotencyKey({
  buyerId,
  checkoutNonce,
  cartFingerprint,
  pickupLocationId,
  fulfillmentMethod,
  shippingAddressFingerprint,
}: ShopCheckoutIdempotencyInput): string | undefined {
  if (!buyerId || !checkoutNonce) return undefined;

  const keyMaterial = JSON.stringify({
    buyerId,
    checkoutNonce,
    cart: cartFingerprint,
    pickupLocationId: pickupLocationId ?? null,
    shippingAddress: shippingAddressFingerprint ?? null,
    // SHIP is the server default, so only pickup changes the key; existing carts keep theirs.
    ...(fulfillmentMethod === ShopFulfillmentMethod.PICKUP
      ? { fulfillmentMethod }
      : {}),
  });
  return `shop_${sha256(keyMaterial).toString().slice(0, 32)}`;
}

interface PortalMembershipCheckoutIdempotencyInput {
  patientId?: string;
  membershipId?: string;
  checkoutNonce?: string;
  paymentMethodId?: string | null;
}

export function buildPortalMembershipCheckoutIdempotencyKey({
  patientId,
  membershipId,
  checkoutNonce,
  paymentMethodId,
}: PortalMembershipCheckoutIdempotencyInput): string | undefined {
  if (!patientId || !membershipId || !checkoutNonce) return undefined;

  const keyMaterial = JSON.stringify({
    patientId,
    membershipId,
    checkoutNonce,
    paymentMethodId: paymentMethodId ?? null,
  });
  return `portal_membership_${sha256(keyMaterial).toString().slice(0, 32)}`;
}
